import React, { useState } from 'react'
import { colors } from '@argo/principles'
import { rgba } from '@argo/utils'
import styled from '@emotion/styled'
import { JWPlayer as VideoPlayer, config } from 'reaxl-video-player'
import { VIDEO_THUMBNAIL_BASE64 } from './VideoThumbnail'

const WIDTH = 592
const HEIGHT = 333

export default ({ url, updateGlobalState }) => {
  const [videoStarted, setVideoStarted] = useState(false)

  const triggerPlayEvent = () => {
    if (!videoStarted) {
      updateGlobalState({ fireAnalytics: 'video_start' })
      setVideoStarted(true)
    }
  }

  const triggerCompleteEvent = () => {
    updateGlobalState({ fireAnalytics: 'video_complete' })
    setVideoStarted(false)
  }

  const triggerMilestonesEvent = percentage => {
    updateGlobalState({ fireAnalytics: 'video_milestones_' + percentage })
  }

  return (
    <VideoContainer>
      <VideoThumbnailContainer>
        <img src={VIDEO_THUMBNAIL_BASE64} alt="KBB ICO Video Thumbnail" />
        <VideoPlayButton className="thumbnail-play-button" />
      </VideoThumbnailContainer>
      <VideoPlayer
        src={url}
        image={VIDEO_THUMBNAIL_BASE64}
        videoId="landing-video"
        mute={false}
        width="100%"
        height="100%"
        {...{
          config,
          onPlayerReady: () => {},
          onPlay: triggerPlayEvent,
          onCompleted: triggerCompleteEvent,
          onMilestones: triggerMilestonesEvent,
          onReplay: triggerPlayEvent
        }}
      />
    </VideoContainer>
  )
}

const VideoThumbnailContainer = styled.div`
  cursor: wait;
  position: absolute;
`

const VideoPlayButton = styled.div`
  position: absolute;
  width: 60px;
  height: 60px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`

const VideoContainer = styled.div`
  margin-top: 10px;
  margin-bottom: 50px;
  position: relative;

  &,
  #vlanding-video,
  > div,
  img {
    --video-width: min(${WIDTH}px, 90vw);
    width: var(--video-width);
    height: calc(var(--video-width) / ${WIDTH} * ${HEIGHT});
  }

  .jw-display-icon-container {
    border-radius: 50%;
    background-color: transparent;
  }

  .jw-display-icon-container {
    border: none;
  }

  .jwplayer:hover .jw-display-icon-container {
    background-color: transparent;
  }

  .jw-icon-display[aria-label='Start playback'],
  .thumbnail-play-button {
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2OCA2OCI+PGNpcmNsZSBmaWxsPSIjMmI1MTk1IiBjeD0iMzMuNyIgY3k9IjMyLjUiIHI9IjMyIi8+PGNpcmNsZSBjeD0iMzMuNyIgY3k9IjMyLjUiIHI9IjMxIiBmaWxsPSIjRkZGIi8+PHBhdGggZmlsbD0iIzJiNTE5NSIgZD0iTTQ1LjggMzIuNSAyNy42IDQzLjNWMjEuOHoiLz48L3N2Zz4=');
    background-size: contain;
    background-repeat: no-repeat;

    :before {
      display: none;
    }

    :hover {
      filter: drop-shadow(0 0px 20px ${rgba(colors.primary.white, 0.8)});
      :active {
        box-shadow: none;
        circle:nth-of-type(2) {
          fill: ${colors.neutral.doveGray};
        }
      }
      :focus {
        filter: drop-shadow(0 0 8px ${colors.action.darkBrightBlue});
      }
    }
  }
`
